import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import store from './app/store';
import { Provider } from 'react-redux';
import { get_user_id_number } from "./state/initSlice"
import * as serviceWorker from './serviceWorker';
import { pushNoteReceived } from './features/chat/chatSlice'
import { newMessageRecieved } from './features/NewMessageDropdown/slice'
import {
	newGroupFeedNotificationReceived,
	newGroupFeedCommentReceived
} from './features/groupFeed/groupFeedSlice'
import {
	chatRoomPushNoteReceived,
	chatRoomMessageReactionReceived
} from './features/MessageCenter/messageCenterSlice'
import initializers from './app/initializers.js'
import {increment as incrementNewAcitivty} from './features/NotificationBell/slice'



//first check if logged in by looking at get_user_id_number()
// because may reach this page when publically viewing blogpost
store.dispatch(get_user_id_number()).then( res => {
	if (res?.payload?.success === "1") {
		window.DashboardAPI = {
			pushNotificationHandler: payload => {
				const state = store.getState()
				console.log(payload)
				const { notification, data } = payload
				if (notification.recipient_id == state.users.current_user?.user_id_number) {
					if (data.type === 'chat_message') {
						//pull available reactions from state
						const reactions = state.reactions.entities
						//add 0 counts to reactions
						const reactionsWithCounts = {}
						Object.entries(reactions).forEach(([k,v])=>{
							reactionsWithCounts[k] = {...v,count:0}
						})
						notification.reactions = {
							author_reaction_id:0,
							map:reactionsWithCounts
						}
						store.dispatch(chatRoomPushNoteReceived(notification))
					}else if (data.type === 'chat_room_message_reaction') {
						store.dispatch(chatRoomMessageReactionReceived(notification.data))
						store.dispatch(incrementNewAcitivty())
					} else if (data.type === 'feed_post') {
						store.dispatch(newGroupFeedNotificationReceived(notification.data))
					} else if (data.type === 'notification_comment') {
						store.dispatch(newGroupFeedCommentReceived(notification.data))
					}  else if (data.type === 'form_added' || data.type === 'form_completed') {
						store.dispatch(incrementNewAcitivty())
					}
				}
			}
		}
		initializers.forEach(initializer => store.dispatch(initializer()))

	}
})



//expose api for push notes



ReactDOM.render(
	<React.StrictMode>
		<Provider store={store}>
			<App />
		</Provider>
	</React.StrictMode>,
	document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
